import "react-day-picker/dist/style.css";
import { styled as e } from "@lokalise/styled";
import { DayPicker as a } from "react-day-picker";
import { value as d, typography as r } from "../../utils/theme/index.js";
const c = e(a)`
	font-family: ${d("font.family.default")};

	&.rdp {
		--rdp-cell-size: 36px;
		--rdp-accent-color: ${d("color.background.action.primary.default")}; // selected day
		--rdp-background-color: ${d("color.background.action.secondary.hover")};
		margin: 0;
	}

	// days of the week
	.rdp-head_cell {
		text-transform: capitalize;
		${r("body.caption.default")};
		color: ${d("color.text.light.default")};
		cursor: default;
	}

	// days in the currently viewed month
	.rdp-day {
		${r("body.caption.default")};
		border-radius: ${d("radius.m")};
		color: ${d("color.text.default")};
	}

	// days outside the currently viewed month
	.rdp-day_outside {
		color: ${d("color.text.disabled")};
	}

	// selected day
	.rdp-day_selected:not(.rdp-day_disabled) {
		&:not(.rdp-day_range_middle) {
			color: ${d("color.text.inverse")};
		}
		&:hover {
			background-color: ${d("color.background.action.secondary.hover")};
		}
	}

	// today
	.rdp-day_today:not(.rdp-day_selected) {
		${r("body.caption.strong")};
		color: ${d("color.text.active")};
	}

	// disabled days
	.rdp-day_disabled,
	.rdp-button[disabled]:not(.rdp-day_selected) {
		background-color: inherit;
		color: ${d("color.text.disabled")};
		cursor: not-allowed;
		opacity: 1;
	}

	/* Classes for date range selections */

	// days between selected start and end date
	.rdp-day_range_middle {
		background-color: ${d("color.background.surface.middle")};
		color: ${d("color.text.default")};
		border-radius: 0;
	}

	// days between selected start and end date, before selecting an end date
	.rdp-range_entered:not(.rdp-day_range_start):not(.rdp-day_range_end) {
		background-color: ${d("color.background.surface.middle")};
		color: ${d("color.text.default")};
		border-radius: 0;
	}

	// start date
	.rdp-day_range_start {
		border-radius: ${d("radius.m")} 0 0 ${d("radius.m")};
	}

	// end date
	.rdp-day_range_end:not(.rdp-range_first_day) {
		border-radius: 0 ${d("radius.m")} ${d("radius.m")} 0;
	}

	// start and end date on the same date
	.rdp-day_range_start.rdp-day_range_end:not(.rdp-range_first_day) {
		border-radius: ${d("radius.m")};
	}
`;
export {
  c as StyledDatePicker
};
//# sourceMappingURL=styles.js.map
